import { fetchUserAttributes, getCurrentUser } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { useContextData } from "./useContextData";
import { generateClient } from "aws-amplify/api";
import { getFacerevealUser } from "../graphql/queries";

const client = generateClient();

export const useUserData = () => {
  const [loadingUser, setLoadingUser] = useState(false);
  const { setUserInfo } = useContextData();

  const fetchUserInfo = async () => {
    setLoadingUser(true);
    try {
      const user = await getCurrentUser();
      const attributes = await fetchUserAttributes();
      let userDataFromDynamo = null;
      if (attributes.sub) {
        //get user from dynamo
        const result = await client.graphql({
          query: getFacerevealUser,
          variables: { id: attributes.sub },
        });
        userDataFromDynamo = result.data?.getFacerevealUser;
        const timeStamp = new Date().toISOString();

        setUserInfo({
          __typename: "FacerevealUser",
          id: attributes.sub,
          tokens: userDataFromDynamo?.tokens || 0,
          jobs: userDataFromDynamo?.jobs || 0,
          email: attributes.email || "",
          picture: attributes.picture || null,
          createdAt: userDataFromDynamo?.createdAt || timeStamp,
          updatedAt: userDataFromDynamo?.updatedAt || timeStamp,
          owner: attributes.sub,
          refreshedAt: timeStamp,
        });
      }

      // console.log("User attributes:", attributes);
    } catch (error) {
      console.error("Error fetching user info:", error);
    } finally {
      setLoadingUser(false);
    }
  };

  return {
    fetchUserInfo,
    loadingUser,
  };
};
